import { type FC, useId } from "react";

import { IconProps, initializeSvgIconProps } from "mds/utils/images";

export const ChatWithLinesFilledIcon: FC<IconProps> = (props) => {
  const id = useId();

  return (
    <svg {...initializeSvgIconProps({ ...props, viewBox: "0 0 18 18" })}>
      <defs>
        {/* eslint-disable-next-line react/no-unknown-property */}
        <mask id={id} mask-type="luminance">
          <rect fill="white" height="100%" width="100%" x="0" y="0" />
          <path
            d="M5.54871 6.57776L12.8406 6.57776"
            stroke="black"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="0.8"
          />
          <path
            d="M5.54871 9.42542H10.7572"
            stroke="black"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="0.8"
          />
        </mask>
      </defs>
      <path
        d="M1.46562 3.73137C1.125 4.39987 1.125 5.27498 1.125 7.02521V15.4772C1.125 15.8948 1.62993 16.104 1.92524 15.8086L3.94499 13.7889C4.14035 13.5935 4.40531 13.4838 4.68159 13.4838H11.7504C13.5006 13.4838 14.3757 13.4838 15.0442 13.1432C15.6323 12.8435 16.1103 12.3655 16.41 11.7774C16.7506 11.1089 16.7506 10.2338 16.7506 8.4836V7.02521C16.7506 5.27498 16.7506 4.39987 16.41 3.73137C16.1103 3.14334 15.6323 2.66526 15.0442 2.36564C14.3757 2.02502 13.5006 2.02502 11.7504 2.02502H6.12518C4.37496 2.02502 3.49984 2.02502 2.83134 2.36564C2.24331 2.66526 1.76523 3.14334 1.46562 3.73137Z"
        fill="currentColor"
        mask={`url(#${id})`}
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
